import axios from "axios";
import { useEffect } from "react";

const useAxiosHeader = (name: string, value: any) => {
  useEffect(() => {
    if (value) {
      axios.defaults.headers[name] = value;
    } else {
      delete axios.defaults.headers[name];
    }
  }, [name, value]);
};

export default useAxiosHeader;
